// src/firebase.js — MAIN project (zoomdecor-react)

import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { FIREBASE_CLIENT_CONFIG } from "./config/firebaseProject.js";

export const firebaseConfig = FIREBASE_CLIENT_CONFIG;

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");
